import { useTranslation } from "react-i18next";
import { CreateFileModal } from "../CreateFile/CreateFile";
import { NoContent } from "../NoContent/NoContent";
import DetailExportables from "./components/DetailExportables"
import "./Exports.scss";

export const Exportables = ({
  data,
  areThereFiles,
  deleteFunction,
  updateFunctions,
  openModalFromDetail,
  selectedSection,
  showCreateModal,
  setShowCreateModal,
}) => {
  const [t] = useTranslation("exports");

  const ModalContent = () => {
    return (
      <CreateFileModal
        showComponent={showCreateModal}
        stateComponent={setShowCreateModal}
        modalSuccessFunction={updateFunctions.updateAll}
      />
    );
  };

  return (
    <>
      <div className="dyTheme1 dyBorder1 p-sm-4 reportsTable">
        {areThereFiles ? (
          <>
          <DetailExportables
            lastFiles={data}
            areThereFiles={areThereFiles}
            deleteFunction={deleteFunction}
            updateFunctions={updateFunctions}
            openModalFromDetail={openModalFromDetail}
            selectedSection={selectedSection}
          />
          <ModalContent />
          </>
        ) : (
          <NoContent
            text={t("Exports.no_reports_export")}
            useModal
            textBtn={t("Exports.generate_report_file")}
            content={<ModalContent />}
            stateContent={setShowCreateModal}
          />
        )}
      </div>
    </>
  );
};